﻿if (typeof $$epiforms !== 'undefined') {

    $$epiforms(document).ready(function myfunction() {
        $$epiforms('.js-webinar-registration-content div[data-personalized-content="webinarContent"] form').on('formsStartSubmitting', function (data) {
            doSpinnerBySelector($('.js-webinar-registration-content #veWebinarSpinnerContainer'));
        });

        // wait for the forms to load all scripts before attempting to use the external spinner method
        const interval = setInterval(function () {
            if (epi.EPiServer.Forms.__Initialized) {
                syncWebinarRegistrationContent();
                phoneNumberFieldValidation();

                clearInterval(interval);
            }
        }, 500);
    });
}

var emailElements = $('.webinar-registration-form .Email');
if (emailElements != null) {
    emailElements.change(function () {
        loadWebinarSubscriptionContent();
    });
}

var companyElements = $('.webinar-registration-form .Company');
if (companyElements != null) {
    companyElements.change(function () {
        loadWebinarSubscriptionContent();
    });
}

var countryElements = $('.webinar-registration-form select.Country');
if (countryElements != null) {
    countryElements.change(function () {
        loadWebinarSubscriptionContent();
    });
}

window.syncWebinarRegistrationContent = function () {
    window.syncAttemptCount = window.syncAttemptCount || 0;
    var personalizedElement = $('div[data-personalized-content="webinarContent"]');
    var mainPageElement = $('.injected-content');

    if (personalizedElement.length > 0) {
        var hdnPersonalizedPageUrl = $('#hdnWebinarRegistrationContentUrl').val();
        var params = getParamKeyValue(window.location.href);
        var sfveclid = params['sfveclid'];
        if (sfveclid) {
            hdnPersonalizedPageUrl = hdnPersonalizedPageUrl + "&sfveclid=" + sfveclid;
        }
        var cid = params['cid'];
        if (cid) {
            hdnPersonalizedPageUrl = hdnPersonalizedPageUrl + "&cid=" + cid;
        }
        $.ajax({
            type: 'GET',
            url: hdnPersonalizedPageUrl,
            async: true,
            cache: false,
            success: function (data) {
                if (data.RedirectionScript) {
                    personalizedElement.append(data.RedirectionScript);
                }
                else {
                    if ((!data.PollStatus || window.syncAttemptCount === 0) && data.PersonalizedHtml) {
                        personalizedElement.html(data.PersonalizedHtml);
                        mainPageElement.html(data.PersonalizedHtml);
                        $(".register-form-top-content-wrap").remove();
                        $(".register-modal-top-heading").remove();
                    } 

                    if (data.PollStatus && window.syncAttemptCount < 5) {
                        setTimeout(syncWebinarRegistrationContent, 5000);
                        window.syncAttemptCount++;
                    }

                    personalizedElement.show();
                    mainPageElement.show();
                    //$('.modal-backdrop').hide();
                    //$('body').removeClass('modal-open');

                }
                stopSpinnerBySelector(null, $('.js-webinar-registration-content #veWebinarSpinnerContainer'));
            },
            error: function (result) {
            }
        });
    }
}

var IndividualInvestor = 'Individual Investor';
var investorTypeElement = $('.InvestorType');
var lastSelection = investorTypeElement.val();

function loadWebinarSubscriptionContent() {
    var webinarSubscriptionContent = $('div[data-personalized-content="subscriptionContent"]');
    var investorType = $('.InvestorType').val();
    var companyName = $('.Company').val();
    var country = $('.Country').val();
    var hdnWebinarSubscriptionContentUrl = $('#hdnWebinarSubscriptionContentUrl').val();
    var hdnWebinarEventId = $('#hdnWebinarEventId').val();
    var hdnWebinarSubscriptionBlockId = $('#hdnWebinarSubscriptionBlockId').val();
    var email = emailElements.length > 0 ? emailElements.val() : '';
    if (webinarSubscriptionContent.length > 0) {
        console.log(investorType);
        $.ajax({
            type: 'GET',
            url: hdnWebinarSubscriptionContentUrl,
            async: true,
            cache: false,
            data: {
                eventid: hdnWebinarEventId,
                investorType: investorType,
                email : email,
                blockId: hdnWebinarSubscriptionBlockId,
                companyName: companyName,
                country: country
            },
            success: function (data) {
                if (data.PersonalizedHtml) {
                    webinarSubscriptionContent.html(data.PersonalizedHtml);
                }
                webinarSubscriptionContent.show();
            },
            error: function (result) {
            }
        });
    }
}

loadWebinarSubscriptionContent();

investorTypeElement.change(function () {
    var currentSelection = investorTypeElement.val();
    if (currentSelection != null && (lastSelection === null || lastSelection === IndividualInvestor || currentSelection === IndividualInvestor) && (lastSelection !== currentSelection)) {
        loadWebinarSubscriptionContent();
    } else {
    }
    if (currentSelection !== null) {
        lastSelection = currentSelection;
    }
});

window.completeWebinarRegistration = function completeWebinarRegistration($this) {
    doSpinnerBySelector($('.js-webinar-registration-content #veWebinarSpinnerContainer'));
    var completeRegistrationUrl = $this.val();
    var paramkeys = getParamKeyValue(window.location.href);
    $.each(paramkeys, function (i, key) {
        completeRegistrationUrl = completeRegistrationUrl + "&" + key + "=" + paramkeys[key];
    });
    var subscriptions = $('input:checked').map(function () { return this.value; }).get().join(",");
    var pageId = $('div[data-personalized-content="webinarContent"]').data('page-id');
    completeRegistrationUrl = completeRegistrationUrl + "&pageId=" + pageId;
    completeRegistrationUrl = completeRegistrationUrl + "&selectedSubscriptions=" + subscriptions;

    $.ajax({
        type: 'POST',
        url: completeRegistrationUrl,
        async: true,
        cache: false,
        success: function (data) {
            syncWebinarRegistrationContent();
        },
        error: function (result) {
        }
    });
}

//WEBP- 4123 Validation for phone number field
function phoneNumberFieldValidation() {
    if ($("body.us-webinar-page").length === 0) return;
    var phoneNumberField = $("body.us-webinar-page .event-registration .Phone");
    if (phoneNumberField.length == 1) {
        $.getScript('/Static/js/jquery/jquery.maskedinput.js')
            .done(function () {
                phoneNumberField.mask("(999) 999-9999");
            })
            .fail(function () {
                console.error("Masked input plugin failed to load");
            });
    };

    if ($(".SelfDeclaredFundsOwned").length > 0) {
        $(".SelfDeclaredFundsOwned").parent().addClass("SelfDeclaredFundsOwned-parent");
        $("div[data-personalized-content=subscriptionContent]").addClass("subscriptionContent-parent");
    }

}